import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_path_step = _resolveComponent("path-step")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.chapter.name), 1),
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chapter.steps, (step) => {
      return (_openBlock(), _createBlock(_component_path_step, {
        key: step.topic.id,
        step: step,
        onShowLoginPopup: _ctx.toggleLogin
      }, null, 8, ["step", "onShowLoginPopup"]))
    }), 128))
  ], 64))
}